document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-articles");
  const blogLinks = document.querySelectorAll(".blog-navigation a");
  const currentUrl = window.location.pathname;

  blogLinks.forEach((link) => {
    const linkUrl = link.getAttribute("href");

    // Check if the current URL matches the blog link URL
    if (currentUrl === linkUrl) {
      link.classList.add("active");
    }

    link.addEventListener("click", function (event) {
      if (this.getAttribute("data-filter") !== "black") {
        return; // Allow the link to navigate to the blog page if it's not the 'ALL' filter
      }
      event.preventDefault();
      blogLinks.forEach((l) => l.classList.remove("active"));
      this.classList.add("active");
    });
  });

  searchInput.addEventListener("input", function () {
    const query = this.value.toLowerCase();
    const articles = document.querySelectorAll(".blog-posts-grid > div");

    articles.forEach((article) => {
      const text = article.innerText.toLowerCase();
      article.style.display = text.includes(query) ? "" : "none";
    });
  });
});
